<template>
    <div class="container">
        <md-dialog :md-active.sync="modalEditar" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <!-- <pre>{{ infoEdit }}</pre> -->
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h5>{{ infoEdit[0].tipo_tercero }}</h5>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoEdit[0].descripcion" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="6" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="3">
                        <md-button class="md-primary" @click="guardarTipoTercero">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteTercero" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>
import TipoTercero from '../../../services/TipoTerceros'
import InacticaItem from '../../utils/InacticaItem.vue'
export default {
    name:'Editar',
    props:['modalEditar','infoEdit'],
    components: {InacticaItem},
    data:() => ({
        codigo : "",
        descripcion : "",
        deleteTercero : false,
        idTipoTercero : null
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar tipo tercero",
                    codigo : "Código",
                    descripcion : "Descripción",
                    save : "Guardar",
                    close : "Cerrar",
                    delete : 'Eliminar'
                }
            }else{
                return {
                    title: "Edit tipo tercero",
                    codigo : "Code",
                    descripcion : "Description",
                    save : "Sava",
                    close : "Close",
                    delete : 'Delete'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTipoTercero(){
            if(this.infoEdit[0].descripcion == ''){
                this.$toast.error('Campo pendiente por diligenciar')
            }else{

                let info = {
                    'idTipoTercero' : this.infoEdit[0].id,
                    'descripcion' : this.infoEdit[0].descripcion,
                    'idUser' : this.$store.state.userId
                }

                TipoTercero.updateTerceroById(info)
                .then((res) => {
                    // this.$toast.success(res.data.message)
                    // location. reload()
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo tercero ya existe.')
                    }
                })
                .catch((error) => error)
            }
        },
        cierraModalDelet(){
            this.deleteTercero = false
        },
        eliminaRegistro(){
            this.idTipoTercero = this.infoEdit[0].id
            this.deleteTercero = true
        },
        confirmInactivate(){
            console.log(this.idTipoTercero);
            TipoTercero.deleteTipoTercero(this.idTipoTercero)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()
                
                }
            })
            .catch((error) => error)
        }
    }
}
</script>

<style>

</style>